




























































import { IEvent } from '@/store/types';
import Vue, { PropType } from 'vue';

const customerStatus = {
  Preview: 'text-gray-700 bg-gray-400 bg-opacity-10 ring-gray-100',
  Production: 'text-indigo-400 bg-indigo-400 bg-opacity-10 ring-indigo-100',
};

export default Vue.extend({
  name: 'CustomerEventCard',
  data() {
    return {
      customerStatus,
    };
  },
  props: {
    event: {
      type: Object as PropType<IEvent>,
      required: true,
    },
  },
  computed: {
    eventData(): Record<string, any> {
      return this.event.eventData || {};
    },
    customerRecord(): Record<string, any> {
      return this.event.customerRecord || {};
    },
    userRecord(): Record<string, any> {
      return this.event.userRecord || {};
    },
    userLabel(): string | null {
      if (this.userRecord) {
        const recordData = this.userRecord.data || {};
        const { name, email } = recordData;
        return name || email || this.userRecord.uid;
      }
      return null;
    },
    customerLabel(): string | null {
      if (this.customerRecord) {
        const recordData = this.customerRecord.data || {};
        const { name, email } = recordData;
        return name || email || this.customerRecord.uid;
      }
      return null;
    },
    eventDataList(): any[] {
      return Object.keys(this.eventData).map((key) => {
        return {
          key,
          value: this.eventData[key],
          description: `${key}: ${this.eventData[key]}`,
        };
      });
    },
  },
});
